import { PlusCircle } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { useCongress } from "@/features/congress-select/hooks/use-congress";
import { NewsForm } from "@/features/upsert-news/components/news-form";
import { NewsList } from "@/features/upsert-news/components/news-list";
import { pageTitle } from "@/utils/page-title";

function NewsPage() {
  const { t } = useTranslation();
  const { congress } = useCongress();
  const [displayAddNews, setDisplayAddNews] = useState<boolean>(false);
  const [openedItems, setOpenedItems] = useState<string[]>([]);

  return (
    <div className="max-w-96 space-y-4">
      <title>{pageTitle(t("meta.news"))}</title>
      <p className="mb-4 flex items-center text-lg font-semibold">
        {t("newsPage.title")}
        <Button
          size="icon"
          variant="ghost"
          className="ml-2 size-7 rounded-full p-1"
          aria-expanded={displayAddNews}
          role="combobox"
          onClick={() => {
            setDisplayAddNews(true);
            setOpenedItems(["new-news-item"]);
          }}
        >
          <PlusCircle className="size-3.5" />
          <span className="sr-only">{t("newsPage.addNews")}</span>
        </Button>
      </p>
      <Accordion
        type="multiple"
        className="w-full space-y-2"
        value={openedItems}
        onValueChange={setOpenedItems}
      >
        <NewsList congressId={congress.id} />
        {displayAddNews && (
          <AccordionItem value="new-news-item" disabled>
            <AccordionTrigger>
              <span className="material-icons mr-1.5 text-foreground">add</span>
              <span className="mr-auto">{t("newsPage.draft")}</span>
            </AccordionTrigger>
            <AccordionContent>
              <NewsForm
                onClose={() => setDisplayAddNews(false)}
                congressId={congress.id}
              />
            </AccordionContent>
          </AccordionItem>
        )}
      </Accordion>
    </div>
  );
}

export { NewsPage };
